import React from "react"
import { useTranslation } from "react-i18next"
import styles from "./navigation-buttons.module.css"
import SaveCalendarIcon from "@/assets/icons/gestational-calendar/save-calendar-icon.tsx"
import DeleteIcon from "@/assets/icons/misc/delete-icon.tsx"
import { Button } from "@/components/shadcn/button.tsx"
import ShortBottomActionWrapper from "@/components/short-bottom-drawer/short-bottom-action-wrapper.tsx"

interface GenerateCalendarButtonProps {
  onSaveClick: () => void
  onDeleteClick: () => void
}

const GestationalCalendarDraftButtons: React.FC<
  GenerateCalendarButtonProps
> = ({ onSaveClick, onDeleteClick }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.buttonBottomWrapper}>
      <ShortBottomActionWrapper
        height={"fit-content"}
        customStyle={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          paddingBottom: "10px",
        }}
      >
        <Button
          size={"lg"}
          className={"w-full gap-2 text-base"}
          onClick={onSaveClick}
        >
          <SaveCalendarIcon />
          {t("saveCalendar")}
        </Button>
        <Button
          size={"lg"}
          className={"gap-2 border-red-500 text-base text-red-500"}
          variant={"outline"}
          onClick={onDeleteClick}
        >
          <DeleteIcon />
          {t("deleteCalendar")}
        </Button>
      </ShortBottomActionWrapper>
    </div>
  )
}

export default GestationalCalendarDraftButtons
